<template>
    <d-container fluid class="main-content-container px-4">
        <!-- Page Header -->
        <d-row no-gutters class="page-header py-4">
            <d-col class="text-center text-sm-left flex-header mb-sm-0">
                <h3 class="page-title">Nowy komornik</h3>
                <d-button theme="secondary" @click.prevent="$router.push({name: 'bailiffs-list'})"><i class="material-icons">keyboard_backspace</i> Wróć do listy</d-button>
                <d-button :class="{isLoading : submitting}" theme="success" @click.prevent="submitForm"><i class="material-icons">add</i> Dodaj komornika</d-button>
            </d-col>
        </d-row>

        <div v-if="!fetched">
            <h2 class="preloader isLoading">Trwa ładowanie</h2>
        </div>
        <transition name="fade">
            <d-card class="card-small" v-if="fetched">
                <d-card-header>
                    <h6 class="m-0">Dane komornika</h6>
                </d-card-header>
                <d-list-group flush>
                    <d-list-group-item class="p-3">
                        <d-form>

                            <d-form-row>
                                <d-col md="6" class="form-group">
                                    <ss-input v-model="bailiff.name" name="name" label="Imię i nazwisko" placeholder="Imię i nazwisko"></ss-input>
                                </d-col>
                                <d-col md="6" class="form-group">
                                    <label for="phone_number">Telefon</label>
                                    <d-input id="phone_number"
                                             type="text"
                                             name="phone_number"
                                             @input="lar_errors.clear('phone_number')"
                                             :class="{'is-invalid' : lar_errors.has('phone_number')}"
                                             v-model="bailiff.phone_number"
                                             maxlength="9"
                                             placeholder="Nr telefonu" />
                                    <div class="invalid-feedback" v-text="lar_errors.get('phone_number')"></div>
                                    <d-button theme="primary" class="mt-2" @click.prevent="telephonesModal = true"><i class="fa fa-phone mr-1"></i> Dodatkowe numery ({{bailiff.telephones.length}})</d-button>
                                </d-col>
                            </d-form-row>
                            <d-form-row>
                                <d-col md="6" class="form-group">
                                    <ss-input v-model="bailiff.email" name="email" label="Adres e-mail" placeholder="Adres e-mail"></ss-input>
                                </d-col>
                                <d-col md="6" class="form-group">
                                    <ss-input v-model="bailiff.court_name" name="court_name" label="Nazwa sądu" placeholder="Nazwa sądu"></ss-input>
                                </d-col>
                            </d-form-row>
                        </d-form>
                    </d-list-group-item>
                </d-list-group>
                <d-card-header>
                    <h6 class="m-0">Adres kancelarii komorniczej</h6>
                </d-card-header>
                <d-list-group flush>
                    <d-list-group-item class="p-3">
                        <d-form>
                            <d-form-row>
                                <d-col md="6" class="form-group">
                                    <ss-input v-model="bailiff.bailiff_office_name" name="bailiff_office_name" label="Nazwa kancelarii" placeholder="Nazwa kancelarii"></ss-input>
                                </d-col>
                                <d-col md="6" class="form-group">
                                    <ss-input v-model="bailiff.bailiff_office_address" name="bailiff_office_address" label="Ulica i numer" placeholder="Ulica i numer"></ss-input>
                                </d-col>
                            </d-form-row>
                            <d-form-row>
                                <d-col md="6" class="form-group">
                                    <ss-input v-model="bailiff.bailiff_office_house_number" name="bailiff_office_house_number" label="Numer mieszkania" placeholder="Nazwa kancelarii"></ss-input>
                                </d-col>
                                <d-col md="6" class="form-group">
                                    <ss-input v-model="bailiff.bailiff_office_flat_number" name="bailiff_office_flat_number" label="Numer lokalu" placeholder="Numer lokalu"></ss-input>
                                </d-col>
                            </d-form-row>
                            <d-form-row>
                                <d-col md="6" class="form-group">
                                    <label for="bailiff_postcode">Kod pocztowy</label>
                                    <d-input id="bailiff_postcode"
                                             type="text"
                                             name="invoice_postcode"
                                             v-mask="'##-###'"
                                             v-model="bailiff.bailiff_office_post_code"
                                             @input="lar_errors.clear('bailiff_office_post_code')"
                                             :class="{'is-invalid' : lar_errors.has('bailiff_office_post_code')}"
                                             placeholder="00-000" />
                                    <div class="invalid-feedback" v-text="lar_errors.get('bailiff_office_post_code')"></div>
                                </d-col>
                                <d-col md="6" class="form-group">
                                    <ss-input v-model="bailiff.bailiff_office_city" name="bailiff_office_city" label="Miasto" placeholder="Miasto"></ss-input>
                                </d-col>
                            </d-form-row>
                        </d-form>
                    </d-list-group-item>
                </d-list-group>
                <ss-modal
                        v-show="telephonesModal"
                        title="Telephone"
                        intro="bounceIn"
                        outro ="bounceOut">
                    <!-- HEADER -->
                    <div slot = "modal-header" style="display: flex;justify-content: space-between;align-items: center;width: 100%;">
                        <span>Numery telefonów</span>
                        <d-button theme="success" @click.prevent="addTelephone"><i class="material-icons">add</i>Dodaj</d-button>
                    </div>
                    <!-- BODY -->
                    <div slot = "modal-body">
                        <table class="table">
                            <thead>
                            <tr>
                                <td>Numer telefonu</td>
                                <td>Opis</td>
                                <td>Akcje</td>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(telephone, index) in bailiff.telephones" :key="index">
                                <td>
                                    <ss-input type="number" v-model="telephone.phone_number" maxlength="9" name="phone_number" />
                                </td>
                                <td>
                                    <ss-textarea v-model="telephone.description" name="description"></ss-textarea>
                                </td>
                                <td>
                                    <d-button @click.prevent="removeTelephone(index)" theme="danger" class="mr-1 mr-3"><i class="material-icons">delete</i> Usuń</d-button>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <!-- FOOTER -->
                    <div slot = "modal-footer">
                        <d-button @click.prevent="telephonesModal = false" theme="danger">Zamknij</d-button>
                    </div>
                </ss-modal>
            </d-card>
        </transition>
    </d-container>
</template>

<script>
  import LarErrors from '../helpers/Errors';
  import BailiffUtil from '../utils/bailiff'
  import SsModal from '../components/common/SsModal'

  export default {
    name: "BailiffNew",
    components: {
      LarErrors,
      SsModal
    },
    data(){
      return{
        fetched: false,
        lar_errors: LarErrors,
        submitting: false,
        bailiff: _.clone(BailiffUtil),
        telephonesModal: false
      }
    },
    methods: {
      addTelephone() {
        if (this.bailiff.telephones.length === 0 || this.bailiff.telephones[this.bailiff.telephones.length -1].phone_number) {
          this.bailiff.telephones.push({
            phone_number: '',
            description: ''
          })
        }
      },
      removeTelephone(index) {
        this.bailiff.telephones.splice(index, 1);
        this.$forceUpdate();
      },
      submitForm(){
        this.submitting = true;
        if (this.bailiff.telephones.length > 0 && !this.bailiff.telephones[this.bailiff.telephones.length -1].phone_number) {
          this.bailiff.telephones.splice(this.bailiff.telephones.length - 1)
        }
        axios.post('api/bailiff/add-bailiff', this.bailiff).then(response => {
          Vue.swal({
            type: 'success',
            title: 'Komornik został dodany.',
            showConfirmButton: true,
          }).then(() => {
            this.$router.push({name: 'bailiffs-list'});
          });
          this.submitting = false;
        }).catch((error) =>{

          this.submitting = false;
          console.log(error);
          LarErrors.record(error.response.data.errors)
        })
      }
    },
    mounted(){
      this.fetched = true;
    }
  }
</script>
